import { PurchaseRecordPreview } from "./PreviewPurchseOrders.jsx";
export default function Preview({ returnItem, ...props }) {
  return <PurchaseRecordPreview record={returnItem} kind="return" {...props} />;
}
